@for (approval of approvals(); track approval.id) {
  <div class="approval" [class.approval-critical]="approval.severity === 'critical'" data-testid="local-agent-approval">
    <div class="approval-text">
      <span class="approval-title">🔐 {{ approval.title }}</span>
      <span class="approval-description">{{ approval.description }}</span>
    </div>
    <div class="approval-actions">
      @for (decision of approval.allowedDecisions; track decision) {
        <button
          type="button"
          class="approval-button"
          [class.approval-button-deny]="decision === 'deny'"
          [disabled]="isResolving(approval)"
          [attr.data-testid]="'approval-' + decision"
          (click)="decide(approval, decision)"
        >
          {{ labelKey(decision) | translate }}
        </button>
      }
    </div>
  </div>
}
